// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 119 ? "doc" : chunkId) + "." + {"119":"1ee122f8","354":"6735c931","418":"bc77f26b","480":"ed3126d3"}[chunkId] + ".js";
};